export type ValidationFailure =
  | {
      errorCode: string;
      errorMessage: string;
      propertyName: string;
    }
  | {
      error_code: string;
      error_message: string;
      property_name: string;
    };

export function getFailureMessage(failure: ValidationFailure) {
  return "errorMessage" in failure
    ? failure.errorMessage
    : failure.error_message;
}

export function getFailurePropertyName(failure: ValidationFailure) {
  return "propertyName" in failure
    ? failure.propertyName
    : failure.property_name;
}

export function getFailureErrorCode(failure: ValidationFailure) {
  return "errorCode" in failure ? failure.errorCode : failure.error_code;
}
